import { SupportedCountries } from '@oresundsbron/api/src/backend/VehicleInfo';
import { vehicleColorParser } from '@oresundsbron/validators';
import { fromNullable, getOrElse, map } from 'fp-ts/lib/Option';
import { pipe } from 'fp-ts/lib/function';
import { z } from 'zod';

export const createText = (provider: string) => {
  switch (provider) {
    case 'oresundsPay':
      return 'Som kund hos ÖresundsPay måste du registrera ditt Bropass-avtal via Mitt konto.';
    case 'brobizz':
      return 'Som kund hos Brobizz måste du registrera ditt Bropass-avtal via Brobizz hemsida.';
    default:
      return `Om du har en aktiv bizz med ${provider} kan du lägga till den här. Ditt Bropass-avtal knyts då till din bizz och konto hos ${provider}.`;
  }
};

export type VehicleColors = z.output<typeof vehicleColorParser>;

export const veColorList: VehicleColors[] = [
  'black',
  'blue',
  'brown',
  'green',
  'grey',
  'orange',
  'purple',
  'red',
  'white',
  'yellow',
  'other',
];

export const isBvSupportCountry = (
  country: string,
  supportedCountries: SupportedCountries
) =>
  pipe(
    supportedCountries?.supportedCountries,
    fromNullable,
    map((c) => Array.isArray(c) && c.includes(country as string)),
    getOrElse(() => false)
  );

// Below code is refactored out and de-fp-ts'd from pages/index.ts and tested for functional parity.
const rootPagePaths = {
  sv: '/sv/privat',
  da: '/da/private',
  en: '/private', // en is the default locale so we do not need the locale prefix here
};

export const getLocale = (acceptLang?: string) => {
  if (acceptLang?.includes('sv')) return 'sv';
  else if (acceptLang?.includes('da')) return 'da';
  else return 'en';
};

export const getRedirectPath = (acceptLang?: string) => {
  const locale = getLocale(acceptLang);
  return rootPagePaths[locale];
};
